import _ from 'lodash';
import {
  WORKS_RECENTLY_ADDED_ERROR, WORKS_RECENTLY_ADDED_LOADING,
  WORKS_RECENTLY_ADDED_UPDATE
} from "../actions/workRecentlyAddedActions";

const INITIAL_STATE = {
  works: [],
  worksLoading: false,
  worksError: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case WORKS_RECENTLY_ADDED_UPDATE:
      return {
        ...state,
        works: _.mapKeys(action.payload.data, "id"),
        worksError: action.payload.message,
      };
    case WORKS_RECENTLY_ADDED_ERROR:
      return { ...state, worksError: action.payload };
    case WORKS_RECENTLY_ADDED_LOADING:
      return {...state, worksLoading: action.payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/works/reducers/WorksRecentlyAddedReducer.js